import {
  FETCH_PORTFOLIOTREEOFFAMILYCS_BEGIN,
  FETCH_PORTFOLIOTREEOFFAMILYCS_SUCCESS,
  FETCH_PORTFOLIOTREEOFFAMILYCS_FAILURE,
  FETCH_PORTFOLIOFAMILY_BEGIN,
  FETCH_PORTFOLIOFAMILY_SUCCESS,
  FETCH_PORTFOLIOFAMILY_FAILURE,
  FETCH_PORTFOLIOCS_BEGIN,
  FETCH_PORTFOLIOCS_SUCCESS,
  FETCH_PORTFOLIOCS_FAILURE,
} from "../constants/portfolioAttribution";

const initialState = {
  TreeofFamilyCS: [],
  PortfolioFamily: [],
  CSMappingsData:[],
  isLoading: false,
  error: "",
};

export const getPortfolioAttributionReducer = (
  state = initialState,
  action
) => {
  const { type, payload } = action;
  switch (type) {
    case FETCH_PORTFOLIOTREEOFFAMILYCS_BEGIN: {
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    }
    case FETCH_PORTFOLIOTREEOFFAMILYCS_FAILURE:
      return {
        ...state,
        isLoading: false,
        TreeofFamilyCS: null,
      };
    case FETCH_PORTFOLIOTREEOFFAMILYCS_SUCCESS:
      return {
        ...state,
        TreeofFamilyCS: payload.TreeofFamilyCS,
        isLoading: true,
      };
    case FETCH_PORTFOLIOFAMILY_BEGIN: {
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    }
    case FETCH_PORTFOLIOFAMILY_FAILURE:
      return {
        ...state,
        isLoading: false,
        PortfolioFamily: null,
      };
    case FETCH_PORTFOLIOFAMILY_SUCCESS:
      return {
        ...state,
        PortfolioFamily: payload.PortfolioFamily,
        isLoading: true,
      };
    case FETCH_PORTFOLIOCS_BEGIN: {
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    }
    case FETCH_PORTFOLIOCS_FAILURE:
      return {
        ...state,
        isLoading: false,
        CSMappingsData: null,
      };
    case FETCH_PORTFOLIOCS_SUCCESS:
      return {
        ...state,
        CSMappingsData: payload.CSMappingsData,
        isLoading: true,
      };
    default:
      return state;
  }
};

export default getPortfolioAttributionReducer;
